"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const Banner_1 = __importDefault(require("./Banner"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const Page = ({ children, page, noPadding }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const prevPathname = (0, react_1.useRef)(undefined);
    const firstRender = (0, react_1.useRef)(true);
    (0, react_1.useEffect)(() => {
        // Do not set focus to main element when navigating from auth page
        if (!prevPathname.current || prevPathname.current.includes('auth')) {
            prevPathname.current = location.pathname;
            firstRender.current = false;
            return;
        }
        // Do not set focus to main element when refreshing the page
        if (firstRender.current) {
            firstRender.current = false;
            return;
        }
        prevPathname.current = location.pathname;
        const mainElement = document.getElementById('main');
        mainElement === null || mainElement === void 0 ? void 0 : mainElement.focus({ preventScroll: true });
    }, [location.pathname]);
    return ((0, jsx_runtime_1.jsxs)("div", { id: "Page", children: [(page.headerImage || page.headerText) && (0, jsx_runtime_1.jsx)(Banner_1.default, { page: page }), (0, jsx_runtime_1.jsx)("div", { className: (0, classnames_1.default)('page-container', {
                    'mobile-no-padding': page.mobileNoPadding,
                    'p-0': noPadding,
                    'is-auth': _.includes(page.url, 'auth'),
                }), children: children })] }));
};
exports.default = Page;
